import { helpCenterTopicsProductExperienceId } from '@atlassian/help-center-common-util/analytics/ufo/ufo';
import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export const helpCenterTopicsProductExperience = new UFOExperience(helpCenterTopicsProductExperienceId, {
    type: ExperienceTypes.Load,

    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
});
